export const idlFactory = ({ IDL }) => {
  const CallType = IDL.Variant({ Send: IDL.Null, Sign: IDL.Null })
  const BtcNetwork = IDL.Variant({
    Mainnet: IDL.Null,
    Testnet: IDL.Null,
  })
  const Satoshi = IDL.Nat64
  const outpoint = IDL.Record({
    txid: IDL.Vec(IDL.Nat8),
    vout: IDL.Nat32,
  })
  const utxo = IDL.Record({
    height: IDL.Nat32,
    value: Satoshi,
    outpoint: outpoint,
  })
  const Wei = IDL.Nat
  return IDL.Service({
    approve_erc20: IDL.Func(
      [CallType, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat64, IDL.Text],
      [IDL.Variant({ Ok: IDL.Text, Err: IDL.Text })],
      []
    ),
    btc_p2tr_raw_key_address: IDL.Func(
      [IDL.Principal, BtcNetwork],
      [IDL.Variant({ Ok: IDL.Text, Err: IDL.Text })],
      []
    ),
    custom_approve_erc20: IDL.Func(
      [CallType, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat64, IDL.Text, IDL.Text],
      [IDL.Variant({ Ok: IDL.Text, Err: IDL.Text })],
      []
    ),
    custom_deposit_erc20: IDL.Func(
      [CallType, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat64, IDL.Text],
      [IDL.Variant({ Ok: IDL.Text, Err: IDL.Text })],
      []
    ),
    deposit_erc20: IDL.Func(
      [CallType, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat64, IDL.Text],
      [IDL.Variant({ Ok: IDL.Text, Err: IDL.Text })],
      []
    ),
    doge_address: IDL.Func([IDL.Opt(IDL.Principal), IDL.Bool], [IDL.Text], []),
    eth_address: IDL.Func([IDL.Opt(IDL.Principal)], [IDL.Text], []),
    eth_call_contract: IDL.Func(
      [CallType, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat64, IDL.Text, IDL.Text],
      [IDL.Variant({ Ok: IDL.Text, Err: IDL.Text })],
      []
    ),
    mint_cketh: IDL.Func(
      [CallType, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat64],
      [IDL.Variant({ Ok: IDL.Text, Err: IDL.Text })],
      []
    ),
    personal_sign: IDL.Func([IDL.Text], [IDL.Variant({ Ok: IDL.Text, Err: IDL.Text })], []),
    send_btc: IDL.Func(
      [CallType, IDL.Text, Satoshi, IDL.Nat64, BtcNetwork, IDL.Vec(utxo)],
      [IDL.Variant({ Ok: IDL.Text, Err: IDL.Text })],
      []
    ),
    send_erc20: IDL.Func(
      [CallType, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat64, IDL.Text, IDL.Text],
      [IDL.Variant({ Ok: IDL.Text, Err: IDL.Text })],
      []
    ),
    send_eth: IDL.Func(
      [CallType, IDL.Text, Wei, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat, IDL.Nat64],
      [IDL.Variant({ Ok: IDL.Text, Err: IDL.Text })],
      []
    ),
    send_ordinal: IDL.Func(
      [CallType, IDL.Text, IDL.Nat64, BtcNetwork, utxo, utxo],
      [IDL.Variant({ Ok: IDL.Text, Err: IDL.Text })],
      []
    ),
    sign_doge: IDL.Func(
      [IDL.Text, Satoshi, IDL.Nat64, IDL.Vec(utxo), IDL.Bool],
      [IDL.Variant({ Ok: IDL.Text, Err: IDL.Text })],
      []
    ),
    sign_hash: IDL.Func([IDL.Vec(IDL.Nat8)], [IDL.Variant({ Ok: IDL.Text, Err: IDL.Text })], []),
    sign_sol: IDL.Func(
      [IDL.Vec(IDL.Nat8)],
      [IDL.Variant({ Ok: IDL.Vec(IDL.Nat8), Err: IDL.Text })],
      []
    ),
    solana_address: IDL.Func([IDL.Principal], [IDL.Variant({ Ok: IDL.Text, Err: IDL.Text })], []),
    ton_address: IDL.Func([IDL.Principal], [IDL.Variant({ Ok: IDL.Text, Err: IDL.Text })], []),
    transaction_count: IDL.Func(
      [IDL.Opt(IDL.Principal), IDL.Nat64],
      [IDL.Variant({ Ok: IDL.Nat, Err: IDL.Text })],
      []
    ),
  })
}
export const init = ({ IDL }) => {
  return []
}
